import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { Answer } from 'app/shared/models/Answer.model';
import { PermitQues } from 'app/shared/models/permitQues.model';
import { Questionnaire } from 'app/shared/models/Questionnaire.modal';
import { TRCQGroup } from 'app/shared/models/trcQGroup.mode';
import { loadParentChildList } from 'app/shared/Validator/TRCPermits';

@Component({
  selector: 'jhi-eappreg-permit-questions',
  templateUrl: './eappreg-permit-questions.component.html',
  styleUrls: ['./eappreg-permit-questions.component.scss']
})
export class EappregPermitQuestionsComponent implements OnInit {

  DispOnlyInd = 'N'
  DispSeqInd = 'N'

  trcQGroups: TRCQGroup[] = JSON.parse(sessionStorage.getItem("TRCQGroups") ?? "")
  notes = "";
  permitForm = this.formBuilder.group({})
  answers: Answer[] = [];
  qQuestions: Questionnaire[] = [];
  eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
  grpName: any
  trcFormName = ""

  tRCCurrGrpMetaName = sessionStorage.getItem("TRCCurrGrpMetaName") ?? ""

  parent: string[] = []
  children: string[] = []

  constructor(private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router) {
      history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
          history.go(1);
      };
    const currentpage = sessionStorage.getItem("TRCCurrentPage");
    if (currentpage === "eappreg_permit_main") {
      sessionStorage.setItem("TRCCurrentPage", "eappreg_permit_questions")
    } else if (currentpage === "eappreg_permit_questions") {
      // refreshed
    } else {
      // Didn't come from right program so proceed to error page.
      this.router.navigate(['error-page'])
      return;
    }
    this.qQuestions = JSON.parse(sessionStorage.getItem("qPermitQues") ?? "")

    const tRCGroupObj: TRCQGroup = this.trcQGroups.find((ele: TRCQGroup) => ele.metaName === this.tRCCurrGrpMetaName) ?? new TRCQGroup()
    this.grpName = tRCGroupObj.questionGroup.substr(0, tRCGroupObj.questionGroup.length - 1)
    this.notes = tRCGroupObj.notes;
  }

  ngOnInit(): void {
    if (this.tRCCurrGrpMetaName === "POLICEGRP") {
      this.trcFormName = "TRCPLCForm"
    } else if (this.tRCCurrGrpMetaName === "FIREGRP") {
      this.trcFormName = "TRCFREForm"
    } else if (this.tRCCurrGrpMetaName === "TOBACCOGRP") {
      this.trcFormName = "TRCTBCForm"
    }
    
  }
  back(): void {
    this.router.navigate(['/eappreg_questionnaire'])
  }
  eappreg_permit_questions_action(): void {

    Object.keys(this.permitForm.value).forEach((ele: string) => {
      const ansObjIndex = this.answers.findIndex(ansElem=>ansElem.metaName === ele)
      if ( ansObjIndex !== -1) {
        if(this.answers[ansObjIndex].answerTxt === "Y" && this.permitForm.get(ele)?.value === "N"){
          const qChildren:Questionnaire[] = this.qQuestions.filter((questionElem:Questionnaire) => questionElem.dependency === this.answers[ansObjIndex].questionId)
          for(let i=0;i<qChildren.length;i++){
            const dependentAnsObj = this.answers.findIndex(ansObj=> ansObj.metaName === qChildren[i].metaName)
            if(dependentAnsObj !== -1){
              const ans = this.answers[dependentAnsObj]
              ans.answerTxt = ""
              this.answers[dependentAnsObj] = ans
            }
          }
        }
        this.answers[ansObjIndex].answerTxt = this.permitForm.get(ele)?.value
      }
    })
    sessionStorage.setItem(this.trcFormName, JSON.stringify(this.answers))

    this.router.navigate(['/eappreg_permit_main']);
  }

  update(answers: Answer[]): void {
    this.answers = answers;
    sessionStorage.setItem(this.trcFormName, JSON.stringify(answers))
    
  }
  loadParentChildList(data: any): void {
    loadParentChildList(data.childList,data.parentList,this.permitForm)

  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges()
  }

 

}
